/**
 * Directive: signButton
 */
angular.module('acme.common.directive.signButton', [])
.directive('signButton', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/signButton/signButton.tpl.html',
      scope: {
        type: '@',
        size: '@',
        action: '&'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.signButton = {

          type: 'question',
          size: 'md',

          init: function() {
            this.type = this.getType();
            this.size = this.getSize();
          },

          getType: function() {
            var r = 'fa-';

            if ($scope.type) {
              r += $scope.type;
            }else{
              r += this.type;
            }

            return r;
          },

          getSize: function() {

            var r = ' sign-button-';

            switch ($scope.size) {
              case 'lg':
              // falls through
              case 'sm':
              // falls through
              case 'md':
                r += $scope.size;
                break;
              default:
                r += 'md';
                break;
            }

            return r;

          },

          action: function() {
            if (typeof($scope.action) === 'function') {
              $scope.action();
            }
          }

        };

        $scope.signButton.init();

      }]

    };

}]);